import { Map } from 'immutable';

export const productKeyDescription = (productkey) => {
  switch (productkey) {
    case 'fabrication-us-quickturn':
      return 'Pentalogix';
    case 'fabrication-us-excell':
      return 'Excell';
    case 'fabrication-us-ampel':
      return 'Ampel';
    case 'fabrication-offshore-whx':
    case 'fabrication-offshore-whx-covid19':
      return 'WHX';
    default:
      return productkey;
  }
};

export const extractVendorNames = (quote) => {
  if (!quote || !quote.get('line_items')) return null;

  const productRefs = quote.get('line_items')
    .map(li => _.replace(li.get('quote_config_key'), /(-grpa)|(-grpb)/g, ''));
  return productRefs.toSet()
    .toList()
    .filter(vendor => vendor !== 'whx' && vendor !== 'panel-share')
};

export const basicParams = Map({
  material_type     : 'FR4TG180',
  // finish_plating  : 'ENIG',
  copper_inners     : '1 oz',
  copper_outers     : '1 oz',
  solder_color      : 'green',
  solder_sides      : 'Both Sides',
  silkscreen_color  : 'White',
  material_thickness: '0.062',
});

/**
 * check if a Map of parameters include same options of basicParams
 */
export const areSameBasicParams = (params) => {
  const different = basicParams.findEntry((value, key) => value != params.get(key));
  return different === undefined;
}
